import { sendSumoLog } from './sumoLogger';
import { updateStandbyInspectorsList, updateError } from '../../stores/notifications';
import GetApolloClient from '../../Apollo';
import { GET_STANDBY_INSPECTORS_LIST } from '../queries/queries';

/**
 * The Standby Inspectors list.
 *
 * @param token - authentication token from active auth.
 * @param dispatch - redux dispatch to dispatch state changes.
 * @param immediate - whether to immediately return the results (rather than using dispatch)
 * @returns {Promise<[StandbyInspectors]>} - The full list of Standby Inspectors.
 */
export const fetchStandbyInspectorsList = async (
  token,
  dispatch,
  immediate = false
) => {
  const client = GetApolloClient(token);

  try {
    const {
      data: { getStandbyInspectorsList: standbyInspectorsList },
    } = await client.query({ query: GET_STANDBY_INSPECTORS_LIST });

    if (immediate) {
      return standbyInspectorsList;
    }

    updateStandbyInspectorsList(standbyInspectorsList, dispatch);
  } catch (error) {
    const isInternalError = error instanceof Error;
    const errorType = 'fetchStandbyInspectorsList';
    const errorCode = isInternalError ? 500 : error.errorCode;
    sendSumoLog(errorType, error.message, errorCode, dispatch);
    updateError(error, dispatch);
    return null;
  }
};
